import { FunctionComponent } from 'react'
import NextNProgress from 'nextjs-progressbar'

const MisterRouterProgress: FunctionComponent = () => {
  return <NextNProgress color='#0073A8' startPosition={0.3} stopDelayMs={100} height={2} showOnShallow={true} />
}

export default MisterRouterProgress
